import React from 'react'

interface Props {
  value: number
  max?: number
  digits?: number
  scale?: number
  plus?: boolean
}

interface State { }

export class ScoreValue extends React.Component<Props, State> {
  static defaultProps() {
    return {
      value: 0,
      digits: 0,
      scale: 100,
      plus: false,
    }
  }

  constructor(props: Props) {
    super(props)
    this.state = {}
  }

  formatValue(value?: number) {
    const scale = this.props.scale || 100
    value = value || 0
    return (value * scale).toFixed(this.props.digits)
  }

  componentDidMount() {
  }

  public render() {
    return (
      <>
        {this.props.plus && this.props.value > 0 && <span className="score-value-plus-mark">+</span>}
        <span className="score-value">{this.formatValue(this.props.value)}</span>
        {this.props.max !== undefined && <small className="score-max"> / {this.formatValue(this.props.max)}</small>}
      </>
    )
  }
}